var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.terrainOperation,
          expression: "terrainOperation"
        }
      ]
    },
    [
      _c("div", { staticClass: "sm-function-module-content" }, [
        _c("div", { staticClass: "sm-point" }),
        _c("label", { staticClass: "sm-function-module-sub-section-setting" }, [
          _vm._v("地形修改")
        ]),
        _c("div", { staticClass: "boxchild" }, [
          _c(
            "button",
            {
              staticClass: "tbtn tbn1",
              attrs: { type: "button" },
              on: { click: _vm.modifyTerrain }
            },
            [_vm._v(" 修改 ")]
          ),
          _c(
            "button",
            {
              staticClass: "tbtn",
              attrs: { type: "button" },
              on: { click: _vm.clearModify }
            },
            [_vm._v("清除")]
          )
        ]),
        _c("br"),
        _c("div", { staticClass: "sm-point" }),
        _c("label", { staticClass: "sm-function-module-sub-section-setting" }, [
          _vm._v("地形开挖")
        ]),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("label", { staticClass: "span-box2" }, [_vm._v("开挖深度(米)")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.depth,
                expression: "depth"
              }
            ],
            staticClass: "min-input mleft",
            attrs: { min: "0", type: "number" },
            domProps: { value: _vm.depth },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.depth = $event.target.value
              }
            }
          })
        ]),
        _c("div", { staticClass: "editBox" }, [
          _c("label", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v("编辑:")
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isEdit,
                expression: "isEdit"
              }
            ],
            staticStyle: { "margin-left": "5px" },
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.isEdit)
                ? _vm._i(_vm.isEdit, null) > -1
                : _vm.isEdit
            },
            on: {
              change: function($event) {
                var $$a = _vm.isEdit,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isEdit = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isEdit = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isEdit = $$c
                }
              }
            }
          }),
          _vm._v("   "),
          _c("label", [_vm._v("编辑Z轴:")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isEditZ,
                expression: "isEditZ"
              }
            ],
            staticStyle: { "margin-left": "5px" },
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.isEditZ)
                ? _vm._i(_vm.isEditZ, null) > -1
                : _vm.isEditZ
            },
            on: {
              change: function($event) {
                var $$a = _vm.isEditZ,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isEditZ = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isEditZ = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isEditZ = $$c
                }
              }
            }
          })
        ]),
        _c("div", { staticClass: "boxchild" }, [
          _c(
            "button",
            {
              staticClass: "tbtn tbn1",
              attrs: { type: "button" },
              on: { click: _vm.dig, touchstart: _vm.dig }
            },
            [_vm._v(" 开挖 ")]
          ),
          _c(
            "button",
            {
              staticClass: "tbtn",
              attrs: { type: "button" },
              on: { click: _vm.clearDig }
            },
            [_vm._v("清除")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }